/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Nome:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="ingrediente.nome_comum"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Grupo quimico" label-for="input-1">
            <v-select
              class="style-select"
              label="nome"
              :options="quimicos"
              :reduce="(item) => item.id_grupo_quimico"
              v-model="ingrediente.id_grupo_quimico"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Classe de uso" label-for="input-1">
            <v-select
              class="style-select"
              label="nome"
              :options="classes"
              :reduce="(item) => item.id_classe_uso"
              v-model="ingrediente.id_classe_uso"
            >
            </v-select>
          </b-form-group>
        </div>
      </div>
      <b-button
        type="submit"
        variant="success"
        @click.prevent="salvarIngrediente"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import ingredienteAtivoService from '@src/services/ingrediente-ativo'
import grupoQuimicoService from '../services/grupo-quimico'
import classeUsoService from '../services/classe-uso'

import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    ingrediente: {},
  },
  data() {
    return {
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
      quimicos: [],
      classes: [],
    }
  },
  created() {},
  mounted() {
    this.handleGetQuimicos()
    this.handleGetClasseUso()
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    handleGetQuimicos() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      grupoQuimicoService.listar(token).then((response) => {
        console.log(response.data.dados)
        this.quimicos = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetClasseUso() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      classeUsoService.listar(token).then((response) => {
        console.log(response.data.dados)
        this.classes = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    salvarIngrediente() {
      const token = this.$store.state.auth.currentUser.token
      if (this.ingrediente.id_ingrediente_ativo) {
        this.isLoading = this.loading(this.isLoading)
        ingredienteAtivoService
          .update(token, this.ingrediente)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
            this.ingrediente = {}
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        ingredienteAtivoService
          .salvar(token, this.ingrediente)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.ingrediente = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response ? erro.response.data.mensagem : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
  },
}
</script>

<style>
</style>